import React from 'react';
import { useGrades } from 'hooks';
import SelectListGroup from 'components/Common/SelectListGroup';
import { Select as MuiSelect, MenuItem, InputLabel } from '@mui/material';

const Select = ({ filter, graduating, value, error, onChange, selectField, stages, variant, ...rest }) => {
    const [state, actions] = useGrades();

    if (!state.loaded) {
        actions.load();
    }

    let gradeOptions = stages
        ? Object.entries(state.stages).map((k, v) => {
              return { label: +k?.[0] === 0 ? `${k?.[1]}` : `Stage ${k?.[0]}`, value: +k?.[0] };
          })
        : [...state.grades, ...(graduating ? [{ label: 'Graduating', value: -2 }] : [])];

    if (!filter || !Array.isArray(filter)) {
        gradeOptions.shift();
    } else {
        gradeOptions = gradeOptions?.filter((go) => filter?.includes(go.value));
    }

    return selectField ? (
        <>
            <MuiSelect
                name='gradeId'
                labelId='grade-selector'
                value={value}
                error={error}
                onChange={onChange}
                variant={variant || 'outlined'}
                {...rest}
            >
                <MenuItem key={-1} value={-1} disabled>
                    Select a Grade
                </MenuItem>
                {gradeOptions.map((option) => {
                    return (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    );
                })}
            </MuiSelect>
        </>
    ) : (
        <SelectListGroup
            {...rest}
            disableClassName
            options={gradeOptions}
            name='gradeId'
            value={value}
            error={error}
            onChange={onChange}
        />
    );
};

export default Select;
